// extracted by mini-css-extract-plugin
module.exports = {"root":"dropzone_root__24Gy0","disabled":"dropzone_disabled__fstAA"};